import React from "react";
import styles from "./AdminStatus.module.css";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faClock,
  faArchive,
  faBan,
  faCircleQuestion,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { faCalendarCheck } from "@fortawesome/free-regular-svg-icons";
import { ESTABLISHMENT_STATUS, RESERVATION_STATUS } from "../model/enum";

const AdminStatus = (props) => {
  const { t } = useTranslation();

  // RESERVATION_STATUS

  const statusConfig = {
    [RESERVATION_STATUS.CONFIRMED]: {
      className: styles.status_confirmed,
      label: t("commons.states.confirmed"),
      icon: faCheck,
    },
    [RESERVATION_STATUS.ARCHIVED]: {
      className: styles.status_archived,
      label: t("commons.states.archived"),
      icon: faArchive,
    },
    [RESERVATION_STATUS.IN_PROGRESS]: {
      className: styles.status_waiting,
      label: t("commons.states.waiting"),
      icon: faClock,
    },
    [RESERVATION_STATUS.CANCELED]: {
      className: styles.status_canceled,
      label: t("commons.states.canceled"),
      icon: faBan,
    },
    [RESERVATION_STATUS.CREATED]: {
      className: styles.status_created,
      label: t("commons.states.created"),
      icon: faPlus,
    },
    [RESERVATION_STATUS.PASSED]: {
      className: styles.status_passed,
      label: t("commons.states.passed"),
      icon: faCalendarCheck,
    },

    // ESTABLISHMENT_STATUS 
  
    [ESTABLISHMENT_STATUS.ACTIVATED]: {
      className: styles.status_confirmed,
      label: t("commons.states.active"),
      icon: faCheck,
    },
    [ESTABLISHMENT_STATUS.MISSING_INFORMATIONS]: {
      className: styles.status_waiting,
      label: t("commons.states.waiting"),
      icon: faClock,
    },
    [ESTABLISHMENT_STATUS.WAITING_FOR_APPROVAL]: {
      className: styles.status_waiting,
      label: t("commons.states.waitingForApproval"),
      icon: faClock,
    },
    [ESTABLISHMENT_STATUS.DISABLED]: {
      className: styles.status_canceled,
      label: t("commons.states.canceled"),
      icon: faBan,
    },

    // Statuts conversation (Inbox) — voir ConversationStatusEnum côté zorni-controller.
    // "ARCHIVED" partage déjà la config RESERVATION_STATUS.ARCHIVED ci-dessus.
    OPEN: {
      className: styles.status_created,
      label: "Ouverte",
      icon: faClock,
    },
    CLOSED: {
      className: styles.status_confirmed,
      label: "Clôturée",
      icon: faCheck,
    },
  };

  // Si le statut existe dans notre configuration
  if (statusConfig[props.status]) {
    const { className, label, icon } = statusConfig[props.status];

    return (
      <div className={`${styles.status_badge} ${className}`}>
        <span className={styles.status_icon}>
          <FontAwesomeIcon icon={icon} />
        </span>
        <span className={styles.status_text}>{label}</span>
      </div>
    );
  }

  // Fallback pour les statuts non reconnus
  return (
    <div className={`${styles.status_badge} ${styles.status_default}`}>
      <span className={styles.status_icon}>
        <FontAwesomeIcon icon={faCircleQuestion} />
      </span>
      <span className={styles.status_text}>{props.status || "Unknown"}</span>
    </div>
  );
};

export default AdminStatus;
